// extracted by mini-css-extract-plugin
export var split = "StyledTitle-module--split--d40b4";
export var thin = "StyledTitle-module--thin--f00f6";
export var title = "StyledTitle-module--title--7bf09";
export var titles = "StyledTitle-module--titles--632a0";
export var yellow = "StyledTitle-module--yellow--afc40";